"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const AdMobInterstitialAdsRenderer = ({ adMobInterstitialAdsContext, }) => {
    const { Render } = (0, react_1.useContext)(ControlRendererContext_1.default);
    if (!(adMobInterstitialAdsContext === null || adMobInterstitialAdsContext === void 0 ? void 0 : adMobInterstitialAdsContext.adUnitID)) {
        return null;
    }
    return (react_1.default.createElement(Render.InterstitialAd, { adUnitID: adMobInterstitialAdsContext.adUnitID, keywords: adMobInterstitialAdsContext.keywords, requestNonPersonalizedAdsOnly: adMobInterstitialAdsContext
            .requestNonPersonalizedAdsOnly, onClicked: adMobInterstitialAdsContext === null || adMobInterstitialAdsContext === void 0 ? void 0 : adMobInterstitialAdsContext.onClicked, onClosed: adMobInterstitialAdsContext === null || adMobInterstitialAdsContext === void 0 ? void 0 : adMobInterstitialAdsContext.onClosed, onError: adMobInterstitialAdsContext === null || adMobInterstitialAdsContext === void 0 ? void 0 : adMobInterstitialAdsContext.onError, onLeftApplication: adMobInterstitialAdsContext === null || adMobInterstitialAdsContext === void 0 ? void 0 : adMobInterstitialAdsContext.onLeftApplication, onLoaded: adMobInterstitialAdsContext === null || adMobInterstitialAdsContext === void 0 ? void 0 : adMobInterstitialAdsContext.onLoaded, onOpened: adMobInterstitialAdsContext === null || adMobInterstitialAdsContext === void 0 ? void 0 : adMobInterstitialAdsContext.onOpened }));
};
exports.default = AdMobInterstitialAdsRenderer;
